import { Box, Typography } from '@mui/material';
import ButtonComponent from '../FormComponents/Button';
import Modal from '../Modal/Modal';

interface SaveOrResetChangesProps {
  open: boolean;
  close: () => void;
  language: string;
  save: () => void;
  discard: () => void;
  loading?: boolean;
}

function SaveOrResetChanges(props: SaveOrResetChangesProps) {
  const { open, close, save, discard, loading } = props;

  return (
    <Modal
      fullWidth
      open={open}
      onClose={close}
      title={'You have unsaved changes'}
      button={<ButtonComponent text='Discard' variant='outlined' onClick={discard} />}
      secondButton={<ButtonComponent text='Save' onClick={save} loading={loading} />}
      data={
        <Box>
          <Typography variant='body1'>Either save or discard them.</Typography>
        </Box>
      }
    />
  );
}

export default SaveOrResetChanges;
